<template>
  <v-menu
    v-model="menu"
    min-width="450"
    max-width="450"
    max-height="600"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon small v-bind="attrs" v-on="on" @click="getBlocksByTags">
        <v-icon color="grey">
          {{ icon }}
        </v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item v-if="!blocks.length">
        Блоків із заданими тегами не найдено
      </v-list-item>
      <v-list-item v-for="block in blocks" :key="block.id">
        <InfiniteScroll @intersect="handleScroll(block.id)" />
        <DocumentBlockMiniViewer
          :value="block"
          @add="add(block.id)"
          @get-items="getDocumentsByBlock(block.id)"
        />
      </v-list-item>
    </v-list>
    <div class="text-center">
      <DialogItemsList
        v-model="dialog"
        :items="documents"
        :loading="loading"
        header="Список документів"
        @close="dialog = false"
      />
    </div>
  </v-menu>
</template>

<script>
import DocumentBlockMiniViewer from "./DocumentBlockMiniViewer.vue";
import InfiniteScroll from "../../components/InfiniteScroll.vue";
import DialogItemsList from "../../components/DialogItemsList.vue";
import { getBlocks } from "../../backend/document-blocksApi.js";
import { getDocumentsByBlock } from "../../backend/documentsApi.js";

export default {
  components: {
    DocumentBlockMiniViewer,
    InfiniteScroll,
    DialogItemsList,
  },
  props: {
    value: {
      type: Array,
    },
    icon: {
      type: String,
      default: "search",
    },
  },
  data: () => {
    return {
      blocks: [],
      currentPage: 1,
      perPage: 9,
      totalBlocks: 0,
      documents: [],
      dialog: false,
      loading: false,
      menu: false,
    };
  },
  watch: {
    value() {
      this.currentPage = 1;
      this.blocks = [];
    },
  },
  computed: {
    fullItems() {
      const items = this.blocks.filter(
        (item, index, arr) =>
          arr.findIndex(({ id }) => item.id === id) === index
      );
      if (Array.isArray(this.value)) {
        return this.value.concat(items);
      } else if (typeof this.value === "object") {
        return this.value ? [this.value, ...items] : items;
      } else {
        return items;
      }
    },
  },
  methods: {
    handleScroll(id) {
      if (this.totalBlocks <= this.fullItems.length) return;
      const position = this.fullItems.findIndex((item) => item.id === id);

      if (position === this.fullItems.length - 2) {
        this.getMoreBlocks();
      }
    },
    getBlocksByTags() {
      this.$emit("close-menu");
      if (!this.menu && this.blocks.length) {
        return;
      }

      let url = "";
      for (let t = 0; t < this.value.length; t++) {
        url += `&tags=${this.value[t].id}`;
      }
      getBlocks(this.currentPage, this.perPage, url).then((res) => {
        this.totalBlocks = res.totalItems;
        this.blocks = [...this.blocks, ...res.result];
      });
    },
    getMoreBlocks() {
      this.currentPage += 1;
      this.getBlocksByTags();
    },
    add(blockId) {
      this.$emit("add", blockId);
    },
    async getDocumentsByBlock(blockId) {
      this.dialog = true;
      this.loading = true;
      this.documents = [];
      this.documents = await getDocumentsByBlock(blockId);
      this.loading = false;
    },
  },
};
</script>
